import React from 'react';
import PropTypes from 'prop-types';
import AddressBook from '@medflex/components/stories/AddressBook';
import { useHistory, useLocation } from 'react-router';
import { useTranslation } from 'react-i18next';
import usePermissions from '../../hooks/usePermissions';
import useLocationSearchParams from '../../../hooks/useLocationSearchParams';

const AddressBookTitleBarModule = ({ onSearchTermChanged, isGroupsHidden }) => {
  const history = useHistory();
  const location = useLocation();
  const { t } = useTranslation('physician');
  const { sort } = useLocationSearchParams();
  const params = new URLSearchParams(location.search);
  const { hasPatientAccess, hasPhysicianAccess } = usePermissions();

  const pushQueryParams = state => history.push(`?${params.toString()}`, state);

  const handleChangeFilter = val => {
    history.push(`?${val ? `sort=${val}` : ''}`);
    if (val) params.set('sort', val);
    else params.delete('sort');
    pushQueryParams();
  };

  const tabs = [
    { key: 'all', label: t('AddressBookTitleBarModule.tabs.all') },
    ...(hasPatientAccess
      ? [{ key: 'patients', label: t('AddressBookTitleBarModule.tabs.patients') }]
      : []),
    { key: 'staff', label: t('AddressBookTitleBarModule.tabs.staff') },
    ...(hasPhysicianAccess
      ? [{ key: 'physicians', label: t('AddressBookTitleBarModule.tabs.physicians') }]
      : []),

    ...(isGroupsHidden
      ? []
      : [{ key: 'groups', label: t('AddressBookTitleBarModule.tabs.groups') }]),
    ...(hasPatientAccess
      ? [{ key: 'invited', label: t('AddressBookTitleBarModule.tabs.invited') }]
      : []),
    ...(hasPhysicianAccess
      ? [{ key: 'archive', label: t('AddressBookTitleBarModule.tabs.archive') }]
      : []),
  ];

  return (
    <AddressBook.TitleBar
      onSearchTermChanged={onSearchTermChanged}
      onChangeFilter={handleChangeFilter}
      filter={sort}
      tabs={tabs}
      title={t('AddressBookTitleBarModule.title')}
      searchInputPlaceholder={t('AddressBookTitleBarModule.searchInputPlaceholder')}
    />
  );
};

AddressBookTitleBarModule.propTypes = {
  onSearchTermChanged: PropTypes.func,
  isGroupsHidden: PropTypes.bool,
};

export default AddressBookTitleBarModule;
